import withStyles from 'isomorphic-style-loader/withStyles';
import React, { Component } from 'react';
import { Row, Col, Spin, Typography, Collapse } from 'antd';
import { LoadingOutlined, RightOutlined } from '@ant-design/icons';
import Paragraph from 'antd/lib/typography/Paragraph';
import { UIContainer } from '@components';
import { YayasanLoyolaService } from '../../api/services';
import styles from './faq.css';

const { Panel } = Collapse;

const initialState = {
  loading: true,
  data: [],
};

const loadingIcon = (
  <LoadingOutlined style={{ fontSize: 64, color: '#ef712b' }} />
);

class FAQ extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    YayasanLoyolaService.yayasanFaq(this.props.language).then(res => {
      this.setState({
        data: res.data.data,
        loading: false,
      });
    });
  }

  render() {
    const { data, loading } = this.state;
    return (
      <React.Fragment>
        <Spin indicator={loadingIcon} spinning={loading} size="large">
          <div className="appHeader slim">
            <UIContainer>
              <Typography.Title className="appTitle" level={2}>
                FAQ
              </Typography.Title>
            </UIContainer>
          </div>
          <div style={{ padding: '40px 0px', background: '#f1f1f1' }}>
            <UIContainer>
              {data &&
                data.map(res => {
                  return (
                    <Row gutter={[14, 20]}>
                      <div style={{ marginLeft: 14 }}>
                        <Typography.Title level={4}>
                          {res.faqCategory || ''}{' '}
                        </Typography.Title>
                      </div>
                      <Col span={24}>
                        <Collapse
                          expandIcon={({ isActive }) => (
                            <RightOutlined rotate={isActive ? 90 : 270} />
                          )}
                          className={styles.sitecollapse}
                          bordered={false}
                          style={{ background: '#f1f1f1' }}
                          expandIconPosition="right"
                        >
                          {res.listFAQ &&
                            res.listFAQ.map(resList => {
                              return (
                                <Panel
                                  header={resList.question}
                                  key={res.faqNumber}
                                  className={styles.sitepanel}
                                  style={{
                                    background: '#fff',
                                    borderRadius: '5px',
                                  }}
                                >
                                  <Paragraph
                                    style={{ whiteSpace: 'break-spaces' }}
                                  >
                                    {resList.answer}
                                  </Paragraph>
                                </Panel>
                              );
                            })}
                        </Collapse>
                      </Col>
                    </Row>
                  );
                })}
            </UIContainer>
          </div>
        </Spin>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(FAQ);
